import { render, staticRenderFns } from "./RealtimeScreen.vue?vue&type=template&id=7c057998&scoped=true"
import script from "./RealtimeScreen.vue?vue&type=script&lang=js"
export * from "./RealtimeScreen.vue?vue&type=script&lang=js"
import style0 from "./RealtimeScreen.vue?vue&type=style&index=0&id=7c057998&prod&scoped=true&lang=css"
import style1 from "./RealtimeScreen.vue?vue&type=style&index=1&id=7c057998&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c057998",
  null
  
)

export default component.exports